import React, { PureComponent } from "react";

import "./NotFound.less";

class NotFound extends PureComponent {
  render() {
    return (
      <div className="NotFound-page">
        <h1>Página não encontrada</h1>
      </div>
    );
  }
}

export default NotFound;
